<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import {
  BModal, BButton, BAlert, BRow, BCol, BFormGroup, BFormCheckbox, AlertPlugin,
} from 'bootstrap-vue';
import vSelect from 'vue-select';
import { required, email } from '@validations';
import axios from '@/libs/axios';
import ToastificationContent from '@/@core/components/toastification/ToastificationContent.vue';

export default {
  components: {
    BModal,
    BButton,
    BAlert,
    vSelect,
    BRow,
    BCol,
    BFormGroup,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    value: {
      type: Object,
      default: () => ({
        representanteid: '',
        condicaopagamentoid: '',
      }),
      require: true,
    },
    titleModal: {
      type: String,
      default: null,
      require: false,
    },
    idModal: {
      type: String,
      default: null,
      require: false,
    },
    labelBtnOk: {
      type: String,
      default: null,
      require: false,
    },
  },
  computed: {
    dataForm: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  data() {
    return {
      dataFromApiRepresentanteId: '',
      dataFromApiCondicaoPagamentoId: '',
    };
  },
  mounted() {
    this.$root.$on('bv::modal::show', (bvEvent, modalId) => {
      if (modalId === this.idModal) {
        this.onModalShow();
      }
    });
  },
  beforeDestroy() {
    this.$root.$off('bv::modal::show');
  },
  methods: {
    onModalShow() {
      this.fetchDataFromRepresentante();
      this.fetchDataFromCondicaoPagamento();
    },
    async validateForm() {
      // const isValid = await this.$refs.refFormData.validate()
      if (!this.dataForm.representanteid || !this.dataForm.condicaopagamentoid) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Formulário incompleto',
            text: 'Selecione todos os valores obrigatórios.',
            icon: 'AlertTriangleIcon',
            variant: 'warning',
          },
        });
        return;
      }

      if (this.dataForm.representanteid && this.dataForm.condicaopagamentoid) {
        this.$emit('ok', this.dataForm);
        this.$bvModal.hide(this.idModal);
      }
    },
    async fetchDataFromRepresentante() {
      try {
        const response = await axios.get('/representante?perPage=10000');
        this.dataFromApiRepresentanteId = response.data.data;
      } catch (error) {
        console.error('Erro ao chamar a API:', error);
      }
    },
    async fetchDataFromCondicaoPagamento() {
      try {
        const response = await axios.get('/condicao-pagamento?perPage=10000');
        this.dataFromApiCondicaoPagamentoId = response.data.data;
      } catch (error) {
        console.error('Erro ao chamar a API:', error);
      }
    },
  },
};
</script>

<template>
  <b-modal
      no-close-on-backdrop
      no-close-on-esc
      size="md"
      :id="idModal"
      :title="titleModal"
      :ok-disabled="dataForm.isDefault || !dataForm.condicaopagamentoid || !dataForm.representanteid"
      :ok-title="labelBtnOk"
      ok-variant="success"
      cancel-variant="secondary"
      body-bg-variant="light"
      cancel-title="Cancelar"
      @ok="validateForm"
      @cancel="$emit('cancel')"
      @close="$emit('cancel')"
  >
    <validation-observer ref="refFormData">
      <b-form @submit.prevent>
        <b-row>
          <b-col
              cols="12"
              class="mb-1"
          >
            <b-form-group
                label="Representante"
                label-for="representanteid"
            >
              <validation-provider
                  #default="{ errors }"
                  name="Representante"
                  rules="required"
              >
                <v-select
                    v-model="dataForm.representanteid"
                    id="representanteid"
                    :state="errors.length > 0 ? false : null"
                    :options="dataFromApiRepresentanteId"
                    :reduce="option => option.representanteid"
                    :get-option-label="option => `${option.representanteid} - ${option.representantenome}`"
                    placeholder="Digite o representante"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              cols="12"
              class="mb-1"
          >
            <b-form-group
                label="Condição Pagamento"
                label-for="condicaopagamentoid"
            >
              <validation-provider
                  #default="{ errors }"
                  name="Condição Pagamento"
                  rules="required"
              >
                <v-select
                    v-model="dataForm.condicaopagamentoid"
                    id="condicaopagamentoid"
                    :state="errors.length > 0 ? false : null"
                    :options="dataFromApiCondicaoPagamentoId"
                    :reduce="option => option.condicaopagamentoid"
                    :get-option-label="option => `${option.condicaopagamentoid} - ${option.condicaopagamentodescricao}`"
                    placeholder="Digite a condição de pagamento"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
  </b-modal>
</template>
